export const locales = {
	organism: 'Sécurité sociale',
	assuranceMaladie: 'L’Assurance Maladie',
	signature: 'Agir ensemble, protéger chacun',
	risquePro: 'Risques Professionnels'
};
